export default {
    commonText: { list: [] }
};
